import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { TaxonomyLevelEnum } from "../TaxonomyTags.constants";

const {
  colors: { ui },
} = constants;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
}: { BreakpointNames: { xs: string; sm: string; md: string } } =
  constants.breakpoints;

export const recursiveTagCheckboxCss = {
  padding: 0,
};

export const recursiveTagLabelCss = (level: number) => ({
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.heading3,
  color:
    level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL
      ? ui.neutral[700]
      : ui.neutral[600],
  fontWeight: level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL ? 700 : 400,

  "& label::focus-within": {
    outlineOffset: "0px",
  },
});

export const columnsLayout = (level: number): CSSObject => ({
  display: level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL ? "flex" : "grid",
  flexWrap: "wrap",
  alignItems: "flex-start",
});

export const innerTagStyle: CSSObject = {
  width: "396px",
  paddingRight: "8px",

  [mq.upTo(xs)]: {
    maxWidth: "300px",
    minWidth: "230px",
    width: "auto",
  },
};

export const fieldsetCss = (level: number) => ({
  border: "none",
  padding: 0,
  marginBottom: "8px",
  paddingLeft: level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL ? "16px" : "8px",

  display: level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL ? "grid" : "flex",
  gridTemplateColumns:
    level === TaxonomyLevelEnum.MAIN_CATEGORY_LEVEL ? "repeat(1, 1fr)" : "auto",
});
